// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WOScw","colMin":"styles_colMin__-csez"};